/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_EVENT_TO_CALENDAR(state, event) {
      const length = state.calendarEvents.length
      let lastIndex = 0;
      if(length){
          lastIndex = state.calendarEvents[length - 1].id;
      }
      event.id = lastIndex + 1
      const newEvent = Object.assign({}, event);
      state.calendarEvents.push(newEvent);
  },
  EDIT_CALENDAR_EVENT(state, event) {
      const eventIndex = state.calendarEvents.findIndex((e) => e.id == event.id);
      state.calendarEvents[eventIndex].title = event.title;
      state.calendarEvents[eventIndex].start = event.start;
      state.calendarEvents[eventIndex].end = event.end;
      state.calendarEvents[eventIndex].desc = event.desc;
      state.calendarEvents[eventIndex].cssClass = event.cssClass;
      state.calendarEvents[eventIndex].label = event.label;
  },
  REMOVE_CALENDAR_EVENT(state, eventId) {
      const eventIndex = state.calendarEvents.findIndex((e) => e.id == eventId);
      state.calendarEvents.splice(eventIndex, 1);
  },

  // Simple Calendar Mutations
  ADD_EVENT_TO_SIMPLE_CALENDAR(state, event) {
      const length = state.simpleCalendarEvents.length
      let lastIndex = 0;
      if(length){
          lastIndex = state.simpleCalendarEvents[length - 1].id;
      }
      event.id = lastIndex + 1
      const newEvent = Object.assign({}, event);
      state.simpleCalendarEvents.push(newEvent);
  },
  EDIT_SIMPLE_CALENDAR_EVENT(state, event) {
      const eventIndex = state.simpleCalendarEvents.findIndex((e) => e.id == event.id);
      state.simpleCalendarEvents[eventIndex].title = event.title;
      state.simpleCalendarEvents[eventIndex].startDate = event.startDate;
      state.simpleCalendarEvents[eventIndex].endDate = event.endDate;
      state.simpleCalendarEvents[eventIndex].url = event.url;
      state.simpleCalendarEvents[eventIndex].classes = event.classes;
      state.simpleCalendarEvents[eventIndex].label = event.label;
  },
  REMOVE_SIMPLE_CALENDAR_EVENT(state, eventId) {
      const eventIndex = state.simpleCalendarEvents.findIndex((e) => e.id == eventId);
      state.simpleCalendarEvents.splice(eventIndex, 1);
  },
  SIMPLE_CALENDAR_EVENT_DRAGGED(state, payload) {
    // Check if this is a review assignment or complete SOP
    if (payload.event.isReview || payload.event.isCompleteSOP) {
      // Review assignments are computed dynamically and not stored in simpleCalendarEvents
      // The backend API call in the action will handle the persistence
      console.log('Review assignment dragged - handled by backend API');
      return;
    }
    
    // Check if this is a todo event
    if (payload.event.isTodo) {
      // Todo events are also computed dynamically and not stored in simpleCalendarEvents
      console.log('Todo event dragged - not implemented yet');
      return;
    }
    
    // Handle regular calendar events
    // Check if there are any events in the store
    if (!state.simpleCalendarEvents || state.simpleCalendarEvents.length === 0) {
      console.log('No calendar events in store - all events are computed dynamically');
      return;
    }
    
    const eventIndex = state.simpleCalendarEvents.findIndex((e) => e.id == payload.event.id);
    
    // Check if event exists
    if (eventIndex === -1 || !state.simpleCalendarEvents[eventIndex]) {
      console.log('Event not found in store - likely a computed event:', payload.event);
      console.log('Available store events:', state.simpleCalendarEvents.map(e => ({ id: e.id, title: e.title })));
      return;
    }
    
    const event = state.simpleCalendarEvents[eventIndex];
    
    // For regular calendar events, maintain the original duration
    if (event.startDate && event.endDate) {
      const diff = payload.date.getTime() - event.startDate.getTime()
      const newEndDate = new Date(event.endDate.getTime() + diff)
      event.startDate = payload.date;
      event.endDate = newEndDate;
    } else {
      // Fallback for events without proper dates
      event.startDate = payload.date;
      event.endDate = payload.date;
    }
  },

  // Review Assignments Mutations
  LOAD_REVIEW_ASSIGNMENTS(state, assignments) {
    state.reviewAssignments = assignments;
  }
}
